<template>
  <div class="app-select-list">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'AppSelectList',
};
</script>
